import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "calendar";

export const calendarService = {
    getEvents,
    getResources,
    getBookedDates
};

function getEvents(resourceId?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetEvents/?resourceId=${resourceId}`, requestOptions).then(handleResponse);
}

function getResources() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetResources`, requestOptions).then(handleResponse);
}

function getBookedDates(specialist?: any, options?: {
    sessionType?: string | null;
    sessionPeriod?: string | null;
    schoolType?: string | null;
    excludeBookingId?: number | string | null;
}) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    const params = new URLSearchParams();
    if (specialist != null && specialist !== "") {
        params.set("specialist", String(specialist));
    }
    if (options?.sessionType) params.set("sessionType", String(options.sessionType));
    if (options?.sessionPeriod) params.set("sessionPeriod", String(options.sessionPeriod));
    if (options?.schoolType) params.set("schoolType", String(options.schoolType));
    if (options?.excludeBookingId != null && options.excludeBookingId !== "") {
        params.set("excludeBookingId", String(options.excludeBookingId));
    }
    const query = params.toString();
    return fetch(`${API_URL}/${API_NAME}/getBookedDates${query ? `/?${query}` : ""}`, requestOptions).then(handleResponse);
}


